import React, { FunctionComponent } from "react";
import { Button } from "@material-ui/core";

interface LeaveGameButtonProps {
  gameName: string;
  text: string;
  leaveGame: (playerID: string, gameId: string, parentStatus: string) => void;
  myPlayerId: string;
  gameId: string;
}

const LeaveGameButton: FunctionComponent<LeaveGameButtonProps> = props => {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={() =>
        window.confirm(
          `Are you sure you want to leave ${props.gameName} game?`
        ) && props.leaveGame(props.myPlayerId, props.gameId, "created")
      }
    >
      {props.text}
    </Button>
  );
};
export default LeaveGameButton;
